import React from 'react';
import PropTypes from 'prop-types';
import MCTopView from '@learningblocks/exp-constants/lib/Images/microcentrifuge_topview.svg';
import { Image } from '@learningblocks/storybook-components';
import { InteractionArea } from './InteractionArea';

import './style.scss';

export function LidOpen(props) {
  const balancedText = props.balanced ? 'balanced' : 'not balanced'

  const buildTubePositionString = (positions) => {
    const lengths = positions.length
    const twelve = { "1": 12, "2": 1, "3": 2, "4": 3, "5": 4, "6": 5, "7": 6, "8": 7, "9": 8, "10": 9, "11": 10, "12": 11 }
    
    let str = ""
    for (let i = 0; i < positions.length; i++) {
    let shiftedPost = twelve[positions[i]]
      if (i === 0) {
        str += `${shiftedPost}`
      } else if (i !== lengths - 1) {
        str += `, ${shiftedPost}`
      } else {
        str += ` and ${shiftedPost}`
      }
    }
    
    return str
  }
  
  const slotReader = (slots) => {
    let slotsFound = 0
    let positions = []

    if(!slots) {
      return { slotsFound, positionString }
    }
    for (let slot of slots) {
      if (slot.solution) {
        slotsFound += 1;
        positions.push(slot.id)
      }
    }
    const positionString = buildTubePositionString(positions)
    return { slotsFound, positionString }
    
  }

  const {slotsFound, positionString } = slotReader(props.slots)
  
  let screenReaderText = ` The Microcentrifuge is ${balancedText}. There are  ${slotsFound} tubes placed at positions  ${positionString}`;
  return (
    <div className='mc_equipment_topview' tabIndex={"0"}>
      <Image src={MCTopView} alt={`microcentrifuge top view lid open. ${screenReaderText}`} />
      <div
        className='mc_equipment_topview_lid'
        aria-label="slots aria label should be here"
        onClick={props.toggleLid}
      ></div>
      <InteractionArea
        tabindex="0"
        className='mc_equipment_topview_interactionArea'
        onDrop={props.onDrop}
        slots={props.slots}
      />
    </div>
  );
}

LidOpen.propTypes = {
  /**
   * callback for when lid is clicked- open and close lid
   */
  toggleLid: PropTypes.func,
  /**
   * data of all slots
   * slot position start from 1 to 12 ; 1 being at' 12 0 clock' position and so on
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * id of slot
       */
      id: PropTypes.number,
      /**
       * specifies if rotor is present
       */
      rotor: PropTypes.bool,
      /**
       * specifes if solution is present
       */
      tube: PropTypes.bool,
    })
  ),
  /**
   * callback function to trigger on drop
   */
  onDrop: PropTypes.func,
};
